import { makeObservable, observable, runInAction, reaction, toJS, computable, action } from 'mobx';
import reactionCombiner from "../utils/reactionCombiner";
import axios from "../utils/axios";
import {storeGet, storeGetPost} from "../utils/functions";

class categoryEditorStore {
  data={};
  options={};
  field_types={data:null, fetching:false, inited:false};
  groups={data:null, fetching:false, inited:false};
  permissions={data:null, fetching:false, inited:false};
  storages={data:null, fetching:false, inited:false};
  struct={
    elements:{ access:{} },
    sections:{ access:{} }
  };
  all_table_fields={
    fetching:false,
    inited:false,
    data:[],
    last_struct:""
  };
  all_category_fields={
    fetching:false,
    inited:false,
    data:[],
    last_struct:""
  }
  cur_type_view="elements";
  cur_table_view= {type:"main"};
  constructor(dataset) {
    makeObservable(this, {
      data: observable,
      options: observable,
      struct: observable,
      cur_type_view: observable,
      cur_table_view: observable,
      field_types: observable,
      groups: observable,
      permissions: observable,
      storages: observable,
      all_table_fields: observable,
      all_category_fields: observable,
      fetchAllTableFields: action,
      fetchAllCategoryFields: action,
    });

    /*if (dataset.data) {
      this.data = dataset.data;
    }*/

    this.options.inputName = dataset.inputName
    if (dataset.placeholder) {
      this.options.placeholder = dataset.placeholder
    }
    if (dataset.useTime) {
      this.options.useTime = dataset.useTime == 'true' ? true : false;
    } else {
      this.options.useTime = false;
    }

    if (dataset.data) {
      const json = JSON.parse(dataset.data);
      console.log("JSON", json);
      if (json) {
        runInAction(()=>{
          this.struct = json;
          /*if(typeof this.struct.elements.access === "undefined") {
            this.struct.elements.access={};
          }
          if(typeof this.struct.sections.access === "undefined") {
            this.struct.sections.access = {};
          }*/
        });
      }
    }

    const comb = new reactionCombiner();
    comb.addReaction(() => {
      return this.struct.elements.name;
    },()=>{
      this.struct.sections.name=`${this.struct.elements.name}: Секции`;
    }, { fireImmediately: true });
    comb.addReaction(() => {
      return this.struct.elements.code;
    },()=>{
      this.struct.sections.code=`${this.struct.elements.code}_sections`;
    }, { fireImmediately: true });
    comb.addReaction(() => {
      return this.cur_type_view;
    }, () => {
      if (typeof this.curView().add_tables === "undefined") {
        this.curView().add_tables = [];
      }
      if (typeof this.curView().main_table === "undefined") {
        this.curView().main_table = {};
      }
      if (typeof this.curView().multi_fields === "undefined") {
        this.curView().multi_fields = [];
      }
    }, {fireImmediately: true});

    this.fetchFieldTypes();
    this.fetchPermissionsList();
    this.fetchGroups();
    this.fetchStorages();
  }

  fetchGroups() {
    storeGetPost("/sysapi/category/user_group/data", this.groups, {
      order:{id:"asc"}
    }, false, null);
  }
  fetchStorages() {
    storeGet("/sysapi/category_ui/storages", this.storages);
  }  
  fetchPermissionsList() {
    storeGet("/sysapi/category_ui/permissions", this.permissions);
  }
  fetchFieldTypes() {
    storeGet("/sysapi/category_ui/fields", this.field_types);
  }
  addField() {
    this.getCurTableFields().push({
      code:"",
      name:"",
      type:""
    })
  }
  getCurViewFields() {
    return [
      {name:"Москва", code:"moscow"},
      {name:"Сургут", code:"surgut"},
      {name:"Комсомольск-на-Амуре", code:"kms"},
    ];
  }
  addTable() {
    this.curView().add_tables.push({
      fields: [],
      indexes: [],
      unique_indexes: [],
    });
  };
  curView() {
    return this.struct[this.cur_type_view];
  }
  getAllTablesFields() {
    const allFields=[];
    if(this.curView().main_table && this.curView().main_table.fields) {
      this.curView().main_table.fields.forEach((item)=>{
        allFields.push(item);
      })
    }
    if(this.curView().add_tables && this.curView().add_tables.length) {
      this.curView().add_tables.forEach((addTable)=>{
        if(addTable.fields) {
          addTable.fields.forEach((field)=>{
            allFields.push(field);
          })
        }
      })
    }
    return allFields;
  }
  allTablesFields() {
    const tablesGroups = [
      [this.struct[this.cur_type_view].main_table],
      this.struct[this.cur_type_view].add_tables
    ];
    let fields=[];
    tablesGroups.forEach((tables)=>{
      tables.forEach((table)=>{
        if(table.fields) {
          table.fields.forEach((field)=>{
            fields.push(field);
          });
        }
      })
    });
    return fields;

  }
  getCurTableFields() {
    runInAction(()=> {
      if (this.cur_table_view.type !== "multi") {
        if (typeof this.getCurTable().fields === "undefined") {
          this.getCurTable().fields = [];
        }
      }
    });
    if(this.cur_table_view.type === "multi") {
      return this.getCurTable();
    } else {
      return this.getCurTable().fields;
    }
  }
  getCurTable() {
    if(this.cur_table_view.type === "main") {
      if (typeof this.struct[this.cur_type_view].main_table === "undefined") {
        this.struct[this.cur_type_view].main_table = {};
      }
      return this.struct[this.cur_type_view].main_table;
    }
    if(this.cur_table_view.type === "add") {
      if(typeof this.struct[this.cur_type_view].add_tables[this.cur_table_view.index] === "undefined") {
        this.struct[this.cur_type_view].add_tables[this.cur_table_view.index] = {};
      }
      return this.struct[this.cur_type_view].add_tables[this.cur_table_view.index];
    }
    if(this.cur_table_view.type === "multi") {
      if(typeof this.struct[this.cur_type_view].multi_fields === "undefined") {
        this.struct[this.cur_type_view].multi_fields=[];
      }
      return this.struct[this.cur_type_view].multi_fields;
    }
  }
  fetchAllCategoryFields() {
    if(!this.all_category_fields.fetching) {
      const curStruct = JSON.stringify(toJS(this.curView()));
      if (curStruct !== this.all_category_fields.last_struct) {
        this.all_category_fields.fetching = true;
        this.all_category_fields.last_struct = curStruct;
        axios.post(`/sysapi/category_ui/allCategoryFields`, {struct: toJS(this.curView())}).then((data) => {
          runInAction(() => {
            this.all_category_fields.fetching = false;
            this.all_category_fields.inited = true;
            this.all_category_fields.data = data.data.answer;
          });
        });
      }
    }
  }
  fetchAllTableFields() {
    if(!this.all_table_fields.fetching) {
      const curStruct=JSON.stringify(toJS(this.curView()));
      if(curStruct !== this.all_table_fields.last_struct) {
        this.all_table_fields.fetching = true;
        this.all_table_fields.last_struct = curStruct;
        axios.post(`/sysapi/category_ui/allTableFields`, {struct: toJS(this.curView())}).then((data) => {
          runInAction(() => {
            this.all_table_fields.fetching = false;
            this.all_table_fields.inited = true;
            this.all_table_fields.data = data.data.answer;
          });
        })
      }
    }

  }
}

export default categoryEditorStore;